export default "__VITE_ASSET__BxQbyUZz__"